import ErrorPage from './default';
import { DEFAULT_TV as TEXTS } from './constants';

function DefaultTv(props) {
  return (
    <ErrorPage
      {...props}
      title={TEXTS.TITLE}
      iconColor="BLUE"
      iconId="Alerta"
      buttonText={TEXTS.BUTTON_TEXT}
      buttonHref={TEXTS.BUTTON_HREF}
      description={TEXTS.DESCRIPTION}
      showLink={false}
      componentContent="default-tv"
      columnForm
    />
  );
}
export default DefaultTv;
